import React from "react";
import { Container, Row, Col } from "reactstrap";
import IndexNavbar from "components/Navbars/IndexNavbar.js";
import MainFooter from "components/Footers/MainFooter.js";

function ArcheryVaneTorqueResearch() {
  React.useEffect(() => {
    // Redirect to the new archery portal research page
    window.location.href = 'https://archery.robotyze.org/research#vane-research';
  }, []);

  return (
    <>
      <IndexNavbar />
      <div className="page-header page-header-xs" data-parallax="true">
        <div className="filter"></div>
        <Container>
          <div className="motto text-center">
            <h1>Redirecting...</h1>
            <h3>Taking you to the Archery Portal</h3>
          </div>
        </Container>
      </div>
      <div className="section section-light">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" className="text-center">
              <h2>Research Content Has Moved</h2>
              <p>
                Our archery research has moved to a dedicated portal at{" "}
                <a href="https://archery.robotyze.org/research">archery.robotyze.org/research</a>.
              </p>
              <p>You should be automatically redirected in a moment.</p>
              <p>
                If you are not redirected,{" "}
                <a href="https://archery.robotyze.org/research#vane-research">click here</a>.
              </p>
            </Col>
          </Row>
        </Container>
      </div>
      <MainFooter />
    </>
  );
}

export default ArcheryVaneTorqueResearch;
